// extracted by mini-css-extract-plugin
export default {"detailViewInformation":"BaseForm_detailViewInformation__VeiMt","requestField":"BaseForm_requestField__JogV+"};